import { useCallback } from 'react'
import { DefaultValues, FieldValues, UseFormProps, UseFormReturn, useForm } from 'react-hook-form'

interface UseWorkflowConfigFormOptions<T extends FieldValues> {
  defaultValues: DefaultValues<T>
  onChange: (values: T) => void
  formOptions?: Omit<UseFormProps<T>, 'defaultValues' | 'values'>
}

export type WorkflowConfigFormReturn<T extends FieldValues> = UseFormReturn<T> & {
  pushConfig: () => void
}

export const useWorkflowConfigForm = <T extends FieldValues>({
  defaultValues,
  onChange,
  formOptions
}: UseWorkflowConfigFormOptions<T>): WorkflowConfigFormReturn<T> => {
  const form = useForm<T>({
    values: defaultValues as T,
    mode: 'onChange',
    ...formOptions
  })
  const { getValues } = form

  const pushConfig = useCallback(() => {
    onChange(getValues() as T)
  }, [getValues, onChange])

  return {
    ...form,
    pushConfig
  }
}
